import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SharedService {

  constructor() { }

  async waitUntil(time: number) {
    return await new Promise(resolve => {
      const interval = setInterval(() => {
        resolve(true);
        clearInterval(interval);
      }, time);
    });
  }
}
